import { ReactNode } from 'react';
import { Group, Text } from '@mantine/core';
import { TbPointFilled } from 'react-icons/tb';

interface BulletItemProps {
  content: ReactNode;
  ml?: number;
}

export default function BulletItem({ content, ml = 0 }: BulletItemProps) {
  return (
    <Group gap={4} wrap="nowrap" align="flex-start" ml={ml}>
      <TbPointFilled style={{ flexShrink: 0, marginTop: 3 }} />
      <Text fz={14}>{content}</Text>
    </Group>
  );
}
